export const asList = (res) => {
  const body = res?.data;
  if (Array.isArray(body?.data)) return body.data;
  if (Array.isArray(body)) return body;
  return [];
};

export const asOne = (res) => {
  const body = res?.data;
  // Typical Empivo shape: { success, data: deal }
  if (body?.data && typeof body.data === "object" && !Array.isArray(body.data)) {
    return body.data;
  }
  // Already unwrapped deal object
  if (body && typeof body === "object" && !Array.isArray(body) && body.id != null) {
    return body;
  }
  return null;
};

/** Build id → name map from Pipedrive users list response */
export const buildUserMap = (usersRes) => {
  const map = {};
  asList(usersRes).forEach((u) => {
    if (u?.id == null) return;
    map[String(u.id)] = u.name || u.email || `User ${u.id}`;
  });
  return map;
};

export const resolveOwnerName = (deal, userMap = {}) =>
  deal?.owner_name ||
  deal?.user?.name ||
  userMap[String(deal?.owner_id)] ||
  "";

export const resolvePersonName = (deal) => {
  if (!deal) return "";
  if (deal.person_name) return deal.person_name;
  if (deal.person?.name) return deal.person.name;
  // Pipedrive v1 sometimes nests: person_id: { value, name }
  if (deal.person_id && typeof deal.person_id === "object") {
    return deal.person_id.name || deal.person_id.value_name || "";
  }
  return "";
};

export const resolveOrgName = (deal) => {
  if (!deal) return "";
  if (deal.org_name) return deal.org_name;
  if (deal.organization?.name) return deal.organization.name;
  // Pipedrive v1 sometimes nests: org_id: { value, name }
  if (deal.org_id && typeof deal.org_id === "object") {
    return deal.org_id.name || deal.org_id.value_name || "";
  }
  return "";
};
